/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Button } from 'foundations-components/transitional/components/Button';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import { getSignupCtaHref } from '../../utils/urls';
import HeroTypingHeading from './HeroTypingHeading';
import { View } from 'foundations-components/transitional/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { TFlex } from 'foundations-components/transitional/components/TFlex';

// @ts-expect-error img
import HeroImage from 'bender-url!../../../images/homepage/hero-personas/hero-image-compressed.jpeg';
import { Image } from 'foundations-components/transitional/components/Image';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HomepageHeroSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    "data-test-id": "homepage-hero-section",
    paddingBlock: "1100",
    children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        flexDirection: isMobile ? 'column-reverse' : 'row',
        gap: 48,
        children: [/*#__PURE__*/_jsxs(Box, {
          minInlineSize: "60%",
          children: [/*#__PURE__*/_jsx(Tag, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsxs(List, {
              inline: true,
              use: "inline-divided",
              children: [/*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits1"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits2"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits3"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "inherit",
            children: /*#__PURE__*/_jsx(HeroTypingHeading, {})
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.description"
            })
          }), /*#__PURE__*/_jsx(Button, {
            href: getSignupCtaHref('academy-home-hero'),
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.ctaText"
            })
          })]
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(View, {
            borderRadius: "400",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(Image, {
              alt: "Hero image",
              src: HeroImage
            })
          })
        })]
      })
    })
  });
};
export default HomepageHeroSection;